/**
 * @param {string} keyName - A key to identify the value.
 * @param {any} keyValue - A value associated with the key.
 * @param {number} ttl- Time to live in seconds.
 */
const set = (keyName, keyValue, ttl) => {
    const data = {
        value: keyValue,                  // store the value within this object
        ttl: Date.now() + (ttl * 1000),   // store the TTL (time to live)
    }

    // store data in LocalStorage
    localStorage.setItem(keyName, JSON.stringify(data));
};

export default () => {
    let trigger = document.querySelector('.js-confirm-cookies');
    let declineTrigger = document.querySelector('.js-decline-cookies');

    if (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.d2_cookies) {
                window.d2_cookies.gdprAccept();
            }
        });
    }

    if (declineTrigger) {
        // let EXPIRE_TIME = 1209600; // 2 weeks
        let EXPIRE_TIME = 5; // 2 weeks
        declineTrigger.addEventListener('click', function (e) {
            e.preventDefault();

            if (window.d2_cookies) {
                set('tempGDPRDecline', 1, EXPIRE_TIME);
                window.d2_cookies.revokeGdpr();
            }
        });
    }
};